var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#000000;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,0.004C114.609,0.021,0.016,114.613,0,256.004c0.016,141.39,114.609,255.974,256,255.992 c141.39-0.017,255.983-114.601,256-255.992C511.983,114.613,397.39,0.021,256,0.004z M406.683,406.68 c-38.63,38.596-91.774,62.403-150.683,62.412c-58.91-0.009-112.054-23.815-150.684-62.412 c-38.596-38.631-62.403-91.767-62.412-150.676c0.009-58.909,23.815-112.053,62.412-150.684 C143.955,66.724,197.09,42.917,256,42.909c58.909,0.008,112.045,23.815,150.683,62.412c38.598,38.631,62.404,91.775,62.413,150.684 C469.087,314.913,445.281,368.049,406.683,406.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M256,61.888C148.94,61.905,61.909,148.945,61.892,256.004C61.909,363.047,148.94,450.095,256,450.112 c107.058-0.017,194.09-87.065,194.108-194.108C450.09,148.945,363.058,61.905,256,61.888z M381.058,381.063 C348.981,413.116,304.795,432.95,256,432.95c-48.796,0-92.99-19.827-125.058-51.887c-32.062-32.078-51.888-76.264-51.888-125.059 c0-48.803,19.826-92.989,51.888-125.058C163.01,98.877,207.204,79.05,256,79.05c48.795,0,92.981,19.827,125.058,51.896 c32.06,32.069,51.887,76.255,51.887,125.058C432.946,304.799,413.119,348.985,381.058,381.063z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M198.8,226.306c-17.967,0-32.564,14.598-32.564,32.556s14.598,32.555,32.564,32.555 c17.949,0,32.546-14.597,32.546-32.555S216.75,226.306,198.8,226.306z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M313.2,226.306c-17.949,0-32.547,14.598-32.547,32.556s14.598,32.555,32.547,32.555 c17.966,0,32.563-14.597,32.563-32.555S331.165,226.306,313.2,226.306z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonSvgrepoCom);
export default __webpack_public_path__ + "static/media/button-svgrepo-com.3aad6ddeb79e63a7974f320432e50428.svg";
export { ForwardRef as ReactComponent };